import { render, staticRenderFns } from "./AutoBox.vue?vue&type=template&id=c6d2e012"
import script from "./AutoBox.vue?vue&type=script&lang=js"
export * from "./AutoBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports